/**
 * cart-count-sync.js
 * Keeps the header cart icon/count in sync after AJAX add-to-cart (Quick Add etc.)
 *
 * Updates BOTH possible header cart triggers:
 * - Drawer button: .header-actions__cart-button (data-cart-open)
 * - Link icon:     .header-actions__cart-icon (href to cart)
 *
 * Also toggles wrapper "has-items" classes used by your wave/cart fill CSS.
 */

(function () {
  const CART_JS_URL = '/cart.js';

  function $all(sel, root = document) {
    return Array.from(root.querySelectorAll(sel));
  }

  async function fetchCart() {
    const res = await fetch(CART_JS_URL, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!res.ok) throw new Error('Failed to fetch cart.js');
    return res.json();
  }

  function setCountOnHeader(count) {
    const c = Number(count || 0);

    // Update any known count container (optional)
    $all('[data-header-cart]').forEach((el) => el.setAttribute('data-cart-count', String(c)));

    // Update BOTH cart triggers (drawer button + link icon)
    const cartTriggers = $all(
      '.header-actions__cart-button[data-cart-count], .header-actions__cart-icon[data-cart-count], [data-cart-open][data-cart-count]'
    );

    cartTriggers.forEach((el) => {
      el.setAttribute('data-cart-count', String(c));

      // Toggle has-items on the icon wrapper(s) inside the button/link
      const wrappers = [
        el.querySelector('.icon-wave-container'),
        el.querySelector('.cart-custom-icon-wrapper'),
        el.querySelector('.svg-wrapper'),
      ].filter(Boolean);

      wrappers.forEach((w) => {
        w.classList.toggle('has-items', c > 0);
        w.classList.toggle('is-not-empty', c > 0);
      });

      // Also toggle on the trigger itself for any CSS relying on it
      el.classList.toggle('has-items', c > 0);
      el.classList.toggle('is-not-empty', c > 0);
    });

    // Update any visible numeric badge/text nodes if you ever use them
    const countTargets = [
      '[data-cart-count-badge]',
      '.header-actions__cart-count',
      '.cart-count-badge',
      '.cart-count',
    ];

    countTargets.forEach((sel) => {
      $all(sel).forEach((el) => {
        el.textContent = c > 0 ? String(c) : '';
      });
    });

    // Backwards compatibility: toggle common header cart class hooks
    const classTargets = [
      '.header-actions__cart-icon',
      '.header-actions__cart-button',
      '.header-actions__cart-link',
      '.header-actions__cart',
      '.svg-wrapper',
    ];

    classTargets.forEach((sel) => {
      $all(sel).forEach((el) => {
        if (c > 0) {
          el.classList.add('has-items', 'is-not-empty');
        } else {
          el.classList.remove('has-items', 'is-not-empty');
        }
      });
    });
  }

  async function syncCartCount() {
    try {
      const cart = await fetchCart();
      setCountOnHeader(Number(cart.item_count || 0));
    } catch (e) {
      console.warn('[cart-count-sync]', e);
    }
  }

  // Listen for common theme events (some dispatch on window, some on document)
  window.addEventListener('cart:update', syncCartCount);
  window.addEventListener('cart:refresh', syncCartCount);
  document.addEventListener('cart:update', syncCartCount);
  document.addEventListener('cart:refresh', syncCartCount);

  // Run once on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartCount);
  } else {
    syncCartCount();
  }
})();
